import React from 'react';

import { BadgeProps } from '@pflegia/types/common/interfaces/badge';
import { mergeTailwindClasses } from '@pflegia/util/functions/style/merge-tailwind-classes';

export const Badge: React.FC<BadgeProps> = ({ children, colorScheme, className, loading }) =>
  loading ? (
    <div className={mergeTailwindClasses('h-7 w-24 animate-pulse rounded-full bg-gray-200 p-1 text-sm', className)}> </div>
  ) : (
    <div
      className={mergeTailwindClasses(
        'max-w-full rounded-full p-1 text-sm',
        colorScheme === 'primary' && 'bg-funnel-blue px-6 text-white',
        colorScheme === 'secondary' && 'bg-primary-badge text-default px-4',
        colorScheme === 'outline' && 'border-secondary text-default border px-4',
        className,
      )}>
      {children}
    </div>
  );
